import { createRouter, createWebHistory } from "vue-router";
import { allRoute } from "@/router/routes";
import { hasPermission } from "@/helpers/permissions";
import { clearSession } from "@/api/http";
import { useAuthStore } from "@/stores/auth";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { getSsoUrl } from "@/helpers/helper";

NProgress.configure({ showSpinner: false });

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: allRoute,
});

router.beforeEach(async (routeTo, routeFrom, next) => {
  NProgress.start();
  const previousPath = routeTo.fullPath;
  const title = routeTo.meta.title;
  if (title) {
    document.title = title.toString();
  }
  const authRequired = routeTo.matched.some((route) => route.meta.authRequired);
  if (authRequired) {
    const authStore = useAuthStore();
    // `user` is in-memory only (no storage), so it is already null after
    // any real page refresh — this still fetches fresh on every reload
    // while avoiding a redundant call on every in-app navigation.
    if (!authStore.user) {
      try {
        await authStore.fetchUser();
      } catch (err) {
        return redirectToLogin(previousPath);
      }
    }
  }

  const requiredPermission = routeTo.meta.permission as unknown as string;
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return next({ name: "error.403" });
  }

  return next();
});

router.afterEach(() => {
  NProgress.done();
});

const redirectToLogin = async (previousPath: string) => {
  clearSession();
  NProgress.done();
  // Pass the original route to the login component
  window.location.href = getSsoUrl() + "/auth/login";
};
export default router;
